'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _authManager = require('./authManager');

var _authManager2 = _interopRequireDefault(_authManager);

var _reduxForm = require('redux-form');

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _background = require('./background');

var _background2 = _interopRequireDefault(_background);

var _payment = require('./payment');

var _payment2 = _interopRequireDefault(_payment);

var _register = require('./register');

var _register2 = _interopRequireDefault(_register);

var _productListPage = require('./productListPage');

var _productListPage2 = _interopRequireDefault(_productListPage);

var _productDetail = require('./productDetail');

var _productDetail2 = _interopRequireDefault(_productDetail);

var _address = require('./address');

var _address2 = _interopRequireDefault(_address);

var _experienceShop = require('./experienceShop');

var _experienceShop2 = _interopRequireDefault(_experienceShop);

var _clearSession = require('./clearSession');

var _clearSession2 = _interopRequireDefault(_clearSession);

var _preselection = require('./preselection');

var _preselection2 = _interopRequireDefault(_preselection);

var _servicesMarket = require('./servicesMarket');

var _servicesMarket2 = _interopRequireDefault(_servicesMarket);

var _merchantAuthentication = require('./merchantAuthentication');

var _merchantAuthentication2 = _interopRequireDefault(_merchantAuthentication);

var _beautifulServices = require('./beautifulServices');

var _beautifulServices2 = _interopRequireDefault(_beautifulServices);

var _groupBuying = require('./groupBuying');

var _groupBuying2 = _interopRequireDefault(_groupBuying);

var _orderList = require('./orderList');

var _orderList2 = _interopRequireDefault(_orderList);

var _orderDetail = require('./orderDetail');

var _orderDetail2 = _interopRequireDefault(_orderDetail);

var _attentionArtwork = require('./attentionArtwork');

var _attentionArtwork2 = _interopRequireDefault(_attentionArtwork);

var _attentionShop = require('./attentionShop');

var _attentionShop2 = _interopRequireDefault(_attentionShop);

var _attentionDesigner = require('./attentionDesigner');

var _attentionDesigner2 = _interopRequireDefault(_attentionDesigner);

var _artSalon = require('./artSalon');

var _artSalon2 = _interopRequireDefault(_artSalon);

var _encyclopedicKnowledge = require('./encyclopedicKnowledge');

var _encyclopedicKnowledge2 = _interopRequireDefault(_encyclopedicKnowledge);

var _serviceDetail = require('./serviceDetail');

var _serviceDetail2 = _interopRequireDefault(_serviceDetail);

var _customProductListPage = require('./customProductListPage');

var _customProductListPage2 = _interopRequireDefault(_customProductListPage);

var _customProductDetail = require('./customProductDetail');

var _customProductDetail2 = _interopRequireDefault(_customProductDetail);

var _shopDetail = require('./shopDetail');

var _shopDetail2 = _interopRequireDefault(_shopDetail);

var _designerDetail = require('./designerDetail');

var _designerDetail2 = _interopRequireDefault(_designerDetail);

var _experienceShopList = require('./experienceShopList');

var _experienceShopList2 = _interopRequireDefault(_experienceShopList);

var _crowdfundingMessage = require('./crowdfundingMessage');

var _crowdfundingMessage2 = _interopRequireDefault(_crowdfundingMessage);

var _preferentialMessage = require('./preferentialMessage');

var _preferentialMessage2 = _interopRequireDefault(_preferentialMessage);

var _orderWriting = require('./orderWriting');

var _orderWriting2 = _interopRequireDefault(_orderWriting);

var _myClients = require('./myClients');

var _myClients2 = _interopRequireDefault(_myClients);

var _clientDetails = require('./clientDetails');

var _clientDetails2 = _interopRequireDefault(_clientDetails);

var _myCommissions = require('./myCommissions');

var _myCommissions2 = _interopRequireDefault(_myCommissions);

var _invoice = require('./invoice');

var _invoice2 = _interopRequireDefault(_invoice);

var _main = require('./main');

var _main2 = _interopRequireDefault(_main);

var _experienceShopDetail = require('./experienceShopDetail');

var _experienceShopDetail2 = _interopRequireDefault(_experienceShopDetail);

var _serviceOrderBuy = require('./serviceOrderBuy');

var _serviceOrderBuy2 = _interopRequireDefault(_serviceOrderBuy);

var _serviceOrderConfirm = require('./serviceOrderConfirm');

var _serviceOrderConfirm2 = _interopRequireDefault(_serviceOrderConfirm);

var _orderEvaluate = require('./orderEvaluate');

var _orderEvaluate2 = _interopRequireDefault(_orderEvaluate);

var _companyInfo = require('./companyInfo');

var _companyInfo2 = _interopRequireDefault(_companyInfo);

var _serviceOrderList = require('./serviceOrderList');

var _serviceOrderList2 = _interopRequireDefault(_serviceOrderList);

var _serviceOrderAcceptance = require('./serviceOrderAcceptance');

var _serviceOrderAcceptance2 = _interopRequireDefault(_serviceOrderAcceptance);

var _groupBuyingOrderList = require('./groupBuyingOrderList');

var _groupBuyingOrderList2 = _interopRequireDefault(_groupBuyingOrderList);

var _groupBuyingOrderDetail = require('./groupBuyingOrderDetail');

var _groupBuyingOrderDetail2 = _interopRequireDefault(_groupBuyingOrderDetail);

var _serviceOrderEvaluate = require('./serviceOrderEvaluate');

var _serviceOrderEvaluate2 = _interopRequireDefault(_serviceOrderEvaluate);

var _characteristicRegional = require('./characteristicRegional');

var _characteristicRegional2 = _interopRequireDefault(_characteristicRegional);

var _workstation = require('./workstation');

var _workstation2 = _interopRequireDefault(_workstation);

var _newMedium = require('./newMedium');

var _newMedium2 = _interopRequireDefault(_newMedium);

var _newMediumGzh = require('./newMediumGzh');

var _newMediumGzh2 = _interopRequireDefault(_newMediumGzh);

var _fidelitySearch = require('./fidelitySearch');

var _fidelitySearch2 = _interopRequireDefault(_fidelitySearch);

var _experienceShopNewDetail = require('./experienceShopNewDetail');

var _experienceShopNewDetail2 = _interopRequireDefault(_experienceShopNewDetail);

var _designerList = require('./designerList');

var _designerList2 = _interopRequireDefault(_designerList);

var _designerProductList = require('./designerProductList');

var _designerProductList2 = _interopRequireDefault(_designerProductList);

var _workstationList = require('./workstationList');

var _workstationList2 = _interopRequireDefault(_workstationList);

var _workStationShopList = require('./workStationShopList');

var _workStationShopList2 = _interopRequireDefault(_workStationShopList);

var _shopProductList = require('./shopProductList');

var _shopProductList2 = _interopRequireDefault(_shopProductList);

var _shopDesignerList = require('./shopDesignerList');

var _shopDesignerList2 = _interopRequireDefault(_shopDesignerList);

var _mainSearchPage = require('./mainSearchPage');

var _mainSearchPage2 = _interopRequireDefault(_mainSearchPage);

var _vrProductPage = require('./vrProductPage');

var _vrProductPage2 = _interopRequireDefault(_vrProductPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import orderCheck from './orderCheck';

// import widgets from './widgets';
// import shoppingCart from './shoppingCart';

// import counter from './counter';

// import multireducer from 'multireducer';
exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routeReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  auth: _auth2.default,
  form: _reduxForm.reducer,
  // multireducer: multireducer({
  //  counter1: counter,
  //  counter2: counter,
  //  counter3: counter
  // }),
  info: _info2.default,
  // widgets,
  // shoppingCart,
  // productExpress,
  // productAuthorization,
  // productInvoice,
  payment: _payment2.default,
  // orderCheck,
  register: _register2.default,
  productListPage: _productListPage2.default,
  customProductListPage: _customProductListPage2.default,
  productDetail: _productDetail2.default,
  customProductDetail: _customProductDetail2.default,
  // preselectionProduct,
  // productPreview,
  address: _address2.default,
  experienceShop: _experienceShop2.default,
  experienceShopDetail: _experienceShopDetail2.default,
  clearSession: _clearSession2.default,
  preselection: _preselection2.default,
  servicesMarket: _servicesMarket2.default,
  merchantAuthentication: _merchantAuthentication2.default,
  // orderPaymentInfoChosen,
  beautifulServices: _beautifulServices2.default,
  groupBuying: _groupBuying2.default,
  background: _background2.default,
  serviceDetail: _serviceDetail2.default,
  shopDetail: _shopDetail2.default,
  designerDetail: _designerDetail2.default,
  experienceShopList: _experienceShopList2.default,
  orderList: _orderList2.default,
  orderDetail: _orderDetail2.default,
  attentionArtwork: _attentionArtwork2.default,
  attentionShop: _attentionShop2.default,
  artSalon: _artSalon2.default,
  attentionDesigner: _attentionDesigner2.default,
  orderWriting: _orderWriting2.default,
  encyclopedicKnowledge: _encyclopedicKnowledge2.default,
  crowdfundingMessage: _crowdfundingMessage2.default,
  preferentialMessage: _preferentialMessage2.default,
  myClients: _myClients2.default,
  myCommissions: _myCommissions2.default,
  invoice: _invoice2.default,
  authManager: _authManager2.default,
  clientDetails: _clientDetails2.default,
  main: _main2.default,
  serviceOrderBuy: _serviceOrderBuy2.default,
  orderEvaluate: _orderEvaluate2.default,
  companyInfo: _companyInfo2.default,
  serviceOrderConfirm: _serviceOrderConfirm2.default,
  serviceOrderList: _serviceOrderList2.default,
  groupBuyingOrderList: _groupBuyingOrderList2.default,
  groupBuyingOrderDetail: _groupBuyingOrderDetail2.default,
  serviceOrderAcceptance: _serviceOrderAcceptance2.default,
  serviceOrderEvaluate: _serviceOrderEvaluate2.default,
  characteristicRegional: _characteristicRegional2.default,
  workstation: _workstation2.default,
  newMedium: _newMedium2.default,
  newMediumGzh: _newMediumGzh2.default,
  fidelitySearch: _fidelitySearch2.default,
  experienceShopNewDetail: _experienceShopNewDetail2.default,
  designerList: _designerList2.default,
  designerProductList: _designerProductList2.default,
  workstationList: _workstationList2.default,
  workStationShopList: _workStationShopList2.default,
  shopProductList: _shopProductList2.default,
  mainSearchPage: _mainSearchPage2.default,
  shopDesignerList: _shopDesignerList2.default,
  vrProductPage: _vrProductPage2.default
});
// import orderPaymentInfoChosen from './orderPaymentInfoChosen';

// import preselectionProduct from './preselectionProduct';
// import productPreview from './productPreview';

// import productExpress from './productExpress';
// import productAuthorization from './productAuthorization';
// import productInvoice from './productInvoice';

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/reducer.js
 ** module id = 1564
 ** module chunks = 0
 **/